import type { NavigationTarget } from '@sveltejs/kit';

/**
 * We allow only these keys in the vanity search params as they can be contained in vanity URLs
 *
 * page: can be used to paginate the results
 * locale: can be used to change the language (useful for debugging and testing environments)
 * filters: can be used to filter for a specific type of results (eg hotels for family)
 *
 * TODO: add filters when the title and description are ready for the filters
 */
const allowedVanitySearchParamKeys = ['page', 'noGarnish'];

/**
 * Check if the given URLSearchParams object contains only the allowed vanity search params
 *
 * Useful to check if a URL is a vanity URL
 */
export function isVanitySearchParams(url: URL) {
	const usp = url.searchParams;
	return usp && Array.from(usp.keys()).every(key => allowedVanitySearchParamKeys.includes(key));
}

export function routeWithoutVanityParams(to: NavigationTarget) {
	return (
		to.route
			.id!.split('/').map((x: string) => {
			if (x[0] === '[' || x[0] === '(') {
				return '';
			} else {
				return x;
			}
		}).join('/').replace(/\/+/g, '/') + to.url.search
	);
}
